import { connect } from 'react-redux';
import FacebookButton from '../components/facebook-button';
import {
  connectWithFacebook,
} from '../actions/index';

const mapStateToProps = ({ session }) => {
  return {
    authentication: session.authentication,
  };
};

const mapDispatchToProps = {
  connectWithFacebook,
};

export default connect(mapStateToProps, mapDispatchToProps)(FacebookButton);



// WEBPACK FOOTER //
// ./src/desktop/containers/facebook-button.container.js